module.exports = "<app-widgets-searchbox config=$ctrl.publicTransportSearchConfig placeholder=\"{{ 'Search' | translate }}\" value=$ctrl.poi.public_transport_stop show-clear=true> </app-widgets-searchbox> ";


//////////////////
// WEBPACK FOOTER
// /app/suissealpine/static/app/poi/edit/publictransport/partial.html
// module id = 442
// module chunks = 0